import { Component, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-wait-for-completion',
    templateUrl: './wait-for-completion.component.html',
    styleUrls: ['./wait-for-completion.component.css'],
    standalone: true,
    imports: [
      MatProgressSpinnerModule
    ]})
export class WaitForCompletionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
